module.exports = __webpack_public_path__ + "static/media/Hitachi -Post 750x500px 02-min.14911bcb.jpg";